import React from 'react'

interface TextAreaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  helper?: string
  rows?: number
}

export const TextArea: React.FC<TextAreaProps> = ({
  label,
  error,
  helper,
  rows = 4,
  className = '',
  ...props
}) => {
  const baseTextAreaClasses = `
    w-full px-4 py-3 border rounded-lg bg-white text-grey-text font-din-pro-regular text-base 
    focus:outline-none focus:ring-2 focus:ring-altovita focus:ring-opacity-20 transition-all duration-200
    resize-none
    ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : 'border-border-color focus:border-altovita'}
  `

  return (
    <div className={`w-full ${className}`}>
      {label && (
        <label className="font-din-pro-medium text-base text-altovita block mb-2">
          {label}
          {props.required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}

      <textarea rows={rows} className={baseTextAreaClasses} {...props} />

      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}

      {helper && !error && (
        <p className="mt-1 text-sm text-grey-text">{helper}</p>
      )}
    </div>
  )
}
